import "./Checkbox.scss";
import { ChangeEvent, useState } from "react";
import IconSwitcher from "../Icon/Icon";

export type CheckboxProps = {
	additionalClassName: string;
	checked: boolean;
	error?: boolean;
	disabled: boolean;
	onChange: (event?: ChangeEvent<HTMLInputElement>) => void;
	middleStatus?: boolean;
	children: React.ReactNode;
	ariaLabel?: string;
};

const Checkbox = ({
	additionalClassName,
	checked,
	disabled,
	onChange,
	error = false,
	middleStatus = false,
	children,
	ariaLabel
}: CheckboxProps): JSX.Element => {
	const [isChecked, setIsChecked] = useState(checked);

	const styleModifier = `${disabled ? "disabled" : checked ? "checked" : error ? "error" : ""} ${
		middleStatus ? "middle" : ""
	}`;

	return (
		<>
			<label
				className="checkbox__wrp"
				onClick={() => {
					setIsChecked(!isChecked);
				}}
				data-testid="atoms-checkbox"
			>
				<input
					type="checkbox"
					className={`checkbox__hidden ${additionalClassName}`}
					defaultChecked={checked}
					disabled={disabled}
					onChange={onChange}
					tabIndex={0}
					aria-label={ariaLabel}
				/>
				<div className={`checkbox__inner ${styleModifier}`} role="presentation">
					{children}
				</div>
				<div className={`checkbox ${styleModifier}`} aria-hidden="true">
					{(middleStatus || checked) && (
						<IconSwitcher
							icon={middleStatus ? "Minus" : "Tick"}
							className="checkbox__icon"
						/>
					)}
				</div>
			</label>
			{!!error && !checked && (
				<p className="error_label" aria-live="assertive" role="alert">
					Questo campo è obbligatorio
				</p>
			)}
		</>
	);
};

export default Checkbox;
